
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Shield, FileText, Users, AlertTriangle } from 'lucide-react';

const NRComplianceInfo: React.FC = () => {
  return (
    <div className="mt-8 space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Shield className="h-5 w-5 text-blue-600" />
            Informações sobre Conformidade NR-1
          </CardTitle>
          <CardDescription>
            Entenda os requisitos da Norma Regulamentadora NR-1 para saúde mental no trabalho
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <h4 className="font-medium flex items-center gap-2">
                <FileText className="h-4 w-4" />
                Requisitos Principais
              </h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Programa de prevenção de riscos psicossociais</li>
                <li>• Treinamento em saúde mental</li>
                <li>• Canal de denúncias confidencial</li>
                <li>• Monitoramento do ambiente de trabalho</li>
              </ul>
            </div>
            
            <div className="space-y-2">
              <h4 className="font-medium flex items-center gap-2">
                <Users className="h-4 w-4" />
                Responsabilidades
              </h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Empregador: Implementar medidas preventivas</li>
                <li>• Supervisores: Identificar sinais de alerta</li>
                <li>• Funcionários: Participar dos treinamentos</li>
                <li>• RH: Manter registros atualizados</li>
              </ul>
            </div>
          </div>
          
          <div className="flex flex-wrap gap-2 mt-4">
            <Badge variant="secondary">
              <AlertTriangle className="h-3 w-3 mr-1" />
              Obrigatório
            </Badge>
            <Badge variant="outline">Vigente desde 2024</Badge>
            <Badge variant="outline">Multa: R$ 5.000 - R$ 50.000</Badge>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NRComplianceInfo;
